import React from 'react';
import { Box, Button, SwipeableDrawer, Typography } from '@mui/material';
import { noop } from 'utils/noop';
import { getNextMonthName } from '../lib/getNextMonthName';
import { formatTimeForWelcomeDrawer } from '../lib/getTimeForNextMonth';

interface WelcomeDrawerProps {
  open: boolean;
  onClose: () => void;
  onOpenForm: () => void;
  timeLeft: { days: number; hours: number; minutes: number; seconds: number };
}

export const WelcomeDrawer = ({
  open,
  onClose,
  onOpenForm,
  timeLeft,
}: WelcomeDrawerProps) => {
  return (
    <SwipeableDrawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      onOpen={noop}
      disableSwipeToOpen
      sx={{ zIndex: 1300 }}
      PaperProps={{
        sx: {
          borderTopLeftRadius: '24px',
          borderTopRightRadius: '24px',
          maxWidth: '100%',
          width: '100%',
        },
      }}
    >
      <Box sx={{ padding: '24px' }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            marginBottom: '20px',
          }}
        >
          <Box
            sx={{
              width: 40,
              height: 4,
              backgroundColor: '#e0e0e0',
              borderRadius: 2,
            }}
          />
        </Box>

        <Typography
          variant="h5"
          align="center"
          sx={{
            fontWeight: 700,
            marginBottom: '16px',
          }}
        >
          Внеси планы на {getNextMonthName()}
        </Typography>

        <Typography
          align="center"
          sx={{
            marginBottom: '24px',
          }}
        >
          До закрытия осталось{' '}
          {formatTimeForWelcomeDrawer(timeLeft.days, timeLeft.hours)}
        </Typography>

        <Button
          fullWidth
          variant="contained"
          size="large"
          onClick={onOpenForm}
          sx={{
            borderRadius: '16px',
            padding: '14px',
            fontSize: '16px',
            fontWeight: 600,
            backgroundColor: '#FFB300',
            '&:hover': {
              backgroundColor: '#FFA000',
            },
          }}
        >
          Занести планы
        </Button>
      </Box>
    </SwipeableDrawer>
  );
};
